import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TConfig } from 'shared/services/loadProject';

const initialState: TConfig = {
  id: 0,
  projectId: 0,
  isActive: false,
  hash: '',
  createdAt: '',
  config: {},
};

const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    setConfig(_, action: PayloadAction<TConfig>) {
      return action.payload;
    },
  },
});

export const { setConfig } = configSlice.actions;
export const configReducer = configSlice.reducer;
